/**
 * @file 孵化器账单列表页面信息保存
 * @params data {
 *  tab：当前账单列表类别
 *  paidPage: 已收款当前页数
 *  paidType：已收款类型
 *  pendingPage: 待收款当前页数
 *  pendingType：待收款类型
 *  pendingRefundPage: 未退款当前页数
 *  pendingRefundType：未退款类型
 *  refundedPage: 已退款当前页数
 *  refundedType：已退款类型
 *  obsoletePage: 作废款当前页数
 *  obsoleteType：作废款类型
 *  incubatorUuid： 孵化器uuid
 * }
 */
const BILL_TAB = 'BILL_TAB';

export function setBillTab(params) {
  return dispatch =>
    dispatch({
      type: BILL_TAB,
      data: params,
    });
}

export function billTab(state = {}, action) {
  switch (action.type) {
    case BILL_TAB:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/bill_tab.js